import { motion } from "framer-motion";
import { Play, Lock, Film } from "lucide-react";

export const PodcastList = ({ monuments, premium, onSelect, onBuy }) => {
  return (
    <div className="min-h-screen pt-16 pb-40 px-5">
      <span className="text-[11px] tracking-[0.3em] uppercase" style={{ color: "#8c7326" }}>Biblioteca</span>
      <h1 className="font-serif-display text-4xl leading-none mt-1" style={{ color: "#f3f4f6" }}>
        Vídeo-pódcasts
      </h1>
      <p className="mt-2 text-sm mb-6" style={{ color: "#9ca3af" }}>
        Un relato de 6 minutos por cada monumento de Lerma.
      </p>

      <div className="space-y-3">
        {monuments.map((m, i) => (
          <motion.button
            key={m.id}
            data-testid={`podcast-item-${m.id}`}
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: i * 0.04, ease: "easeOut" }}
                        onClick={() => (m.video_url && !premium && m.id !== "m-plaza-mayor" ? onBuy() : onSelect(m))}
            className="w-full glass rounded-2xl p-4 flex items-center gap-4 text-left"
          >
            <div className="w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0" style={{ background: "rgba(212,175,55,0.1)", border: "1px solid rgba(212,175,55,0.2)" }}>
              {m.video_url ? (
                               premium || m.id === "m-plaza-mayor" ? <Play size={18} className="gold-text" /> : <Lock size={17} className="gold-text" />
              ) : (
                <Film size={18} style={{ color: "#6b7280" }} />
              )}
            </div>
            <div className="flex-1 min-w-0">
              <p className="font-serif-display text-lg leading-tight truncate" style={{ color: "#f3f4f6" }}>{m.title}</p>
              <p className="text-xs truncate" style={{ color: "#9ca3af" }}>{m.short}</p>
            </div>
            <span className="text-[10px] tracking-widest uppercase flex-shrink-0" style={{ color: m.video_url ? "#d4af37" : "#4b5563" }}>
              {m.video_url ? "6 min" : "Pronto"}
            </span>
          </motion.button>
        ))}
      </div>
    </div>
  );
};
